import { Vehicle, VehicleDraft, Source } from "../../../models/Vehicle";
import { assertString } from "../assert/index";

export const isValidBoxId = (boxId: string): boolean => {
    if(typeof boxId !== 'string')
        return false;

    const match = boxId.match(/^[0-9a-zA-Z]{6}$/);
    return match !== null;
}

// We want to display some meaningfull string into Display column in the grid even Display property is not set
export const getVehicleDisplay = (v: Vehicle | VehicleDraft) => {
    if(v.Display != null && v.Display != '')
        return v.Display;

    if(v.SourceId === Source.BoxId) {
        assertString(v.BoxId);
        return v.BoxId;
    }

    if(v.SourceId === Source.Geotab) {
        assertString(v.GeotabTitle);
        return v.GeotabTitle;
    }

    throw new Error(`Unexpected SourceId: ${v.SourceId}`);
}


// WEBPACK FOOTER //
// ./src/app/utils/draft/Vehicle.ts